<template>
  <PAccordion class="company-wall-questions" value="0">
    <PAccordionPanel
      v-for="question in props.questions"
      :key="question.title"
      class="company-wall-questions__panel"
      :value="question.value"
    >
      <PAccordionHeader class="company-wall-questions__panel__header">{{
        question.title
      }}</PAccordionHeader>
      <PAccordionContent class="company-wall-questions__panel__content">{{
        question.content
      }}</PAccordionContent>
    </PAccordionPanel>
  </PAccordion>
</template>

<script setup lang="ts">
import {
  PAccordion,
  PAccordionContent,
  PAccordionHeader,
  PAccordionPanel,
} from "@solvari/components";

import { useStructuredData } from "~/shared/composables/useMetaData.ts";

const props = defineProps<{
  questions: App.Data.CompanyWallFaqData[];
}>();

/* eslint-disable @typescript-eslint/naming-convention */
useStructuredData(() => {
  return {
    "@type": "FAQPage",
    mainEntity: props.questions.map((question) => ({
      "@type": "Question",
      name: question.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: question.content,
      },
    })),
  };
});
</script>

<style lang="postcss">
.company-wall-questions {
  &__panel {
    &__header {
      @apply text-left text-base font-semibold text-slate-700;
    }
    &__content {
      @apply text-left text-base text-slate-700;
    }

    &__header > svg {
      @apply min-h-4 min-w-4;
    }
  }
}
</style>
